/**
 * Shared prefill semantics for CMS-authored links: used by HTML links tagged
 * gpc-prefillable (utils/html-to-vue.js) and More-page cards with the
 * prefillable toggle. Keep the two behaviours identical.
 */
export function appendPrefillParams(href, prefillable = {}) {
  if (!href) return href;
  prefillable = prefillable || {};

  // 1) Explicit placement: substitute any ${var} placeholders authored in the href (URL-encoded).
  //    Use this to map profile data onto a target's own field names, e.g. entry.123=${email}.
  //    Keys placed this way are skipped in the auto-append step below to avoid duplicates.
  const placedKeys = new Set();
  let result = href.replace(/\$\{(\w+)\}/g, (match, varName) => {
    const value = prefillable[varName];
    if (value) {
      placedKeys.add(varName);
      return encodeURIComponent(value); // encoded so spaces/&/? don't break the query
    }
    return match; // Fallback to original if not found
  });

  // 2) Auto-append every remaining non-empty profile field as a query param. Just marking a
  //    link as prefillable is enough to prefill all fields — no ${...} needed in the CMS.
  const params = Object.entries(prefillable)
    .filter(([key, value]) => value && !placedKeys.has(key))
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`);

  if (params.length) {
    // Insert before any #fragment so the params stay in the query string
    // (form#apply → form?name=...#apply, not form#apply?name=...).
    const hashIndex = result.indexOf('#');
    const base = hashIndex === -1 ? result : result.slice(0, hashIndex);
    const fragment = hashIndex === -1 ? '' : result.slice(hashIndex);
    const separator = base.includes('?') ? '&' : '?';
    result = base + separator + params.join('&') + fragment;
  }

  return result;
}
